import React from "react";

const JobList = React.lazy(() => import("./JobList"));
const JobShow = React.lazy(() => import("./JobShow"));
const JobCreate = React.lazy(() => import("./JobCreate"));
const JobEdit = React.lazy(() => import("./JobEdit"));

export default {
  list: JobList,
  show: JobShow,
  create: JobCreate,
  edit: JobEdit,
};
